<template>
  <div :class="[$style.container, actStatus !== 0 ? $style.container_empty : undefined]">
    <div :class="$style.empty" v-if="actStatus !== 0">
      <img
        :src="`https://static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform/voucherAct/empty.png`"
        alt=""
      />
      <p>{{ actTip }}</p>
    </div>

    <template v-else>
      <!-- 绑定账号 + 活动规则 -->
      <div :class="$style.top">
        <!-- 绑定账号 -->
        <div v-if="game_account" :class="$style.account">已绑定账号：{{ game_account }}</div>
        <div v-else :class="$style.account" @click="handleBindAccount">【绑定账号】</div>
        <!-- 活动规则 -->
        <div :class="$style.rule" @click="handleRule">活动规则</div>
      </div>

      <!-- 多游戏 banner -->
      <template v-if="gameList && gameList.length">
        <Banner
          :gameList="gameList"
          :activeGame="activeGame"
          @chooseGame="chooseGame"
          @reportPoint="reportPoint"
        />
      </template>

      <!-- 创角好礼 -->
      <div :class="$style.create" v-if="expoInfo.role_gift_status === 1">
        <img
          :class="$style.create_icon"
          src="https://assets.hzwxbz2.cn/sy/hm/img/title_create.png"
          alt=""
        />
        <!-- 创角礼包 -->
        <div :class="$style.create_main">
          <!-- 创角 icon -->
          <img :src="expoInfo.role_gift_icon" :class="$style.create_img" />
          <!-- 创角信息 -->
          <div :class="$style.create_content">
            <div :class="$style.create_title">{{ expoInfo.role_show_gift_name }}</div>
            <div :class="$style.create_info">
              {{ `${expoInfo.role_gift_description}` }}
            </div>
            <div :class="$style.create_task">
              {{ `${expoInfo.role_show_condition_rule}` }}
            </div>
          </div>
          <!-- 创角按钮 -->
          <div
            :class="[
              $style.create_button,
              expoInfo.role_gift_receive_status === 1 && $style.receive_done,
            ]"
            @click="handleGetRoleGift"
          >
            {{ expoInfo.role_gift_receive_status === 1 ? '已领取' : '领取' }}
          </div>
        </div>
      </div>

      <!-- 做任务开红包 - icon -->
      <div :class="$style.task_icon">
        <img src="https://assets.hzwxbz2.cn/sy/hm/img/title_task.png" :class="$style.task_img" />
        <div :class="$style.task_countdown">
          剩余时间：
          <van-count-down
            :class="$style.task_count"
            :time="countDownTime"
            format="DD天HH时mm分ss秒"
          />
        </div>
      </div>

      <!-- 做任务开红包 - 标题 -->
      <div :class="$style.task_title">
        <van-notice-bar
          background="transparent"
          color="#ffffff"
          :class="$style.task_notice"
          :text="gameConditionData.packet_text"
        />
      </div>

      <!-- 做任务开红包 - 红包部分 -->
      <div :class="$style.task_container">
        <!-- 奖励介绍 -->
        <div :class="$style.task_intro" @click="handleIntroduce">奖励介绍</div>
        <!-- 领取记录 -->
        <div :class="$style.task_record" @click="handleRewardList">领取记录</div>
        <!-- 红包部分 -->
        <div :class="$style.task_bag" @click="handleOpenReward">
          <img
            :class="$style.task_button"
            src="https://assets.hzwxbz2.cn/sy/hm_act/img/package_button.png"
          />
        </div>
        <!-- 剩余次数 -->
        <div :class="$style.task_times">
          <span>剩余</span>
          <span :class="$style.task_time">{{ gameConditionData.remain_count || 0 }}</span>
          <span>次</span>
        </div>
      </div>

      <!-- 任务奖励 -->
      <div :class="$style.reward" v-if="gameConditionData.condition_list">
        <div
          :class="$style.reward_content"
          v-for="(item, index) in gameConditionData.condition_list"
          :key="index"
        >
          <div :class="$style.reward_info">
            <div :class="$style.reward_title">{{ item.show_condition_rule }}</div>
            <div :class="$style.reward_chance">{{ `开红包机会+${item.count}` }}</div>
          </div>
          <div
            :class="[
              $style.reward_button,
              item.condition_receive_status !== 0 && $style.receive_done,
            ]"
            @click="handleGetReward(item)"
          >
            {{ rewardButtonText(item.condition_receive_status) }}
          </div>
        </div>
      </div>

      <!-- 弹窗类 -->
      <!-- 开红包奖励弹窗 -->
      <transition name="popup-fade">
        <div v-if="showResultPopup" class="blind-box-result-popup">
          <div class="popup-content" :class="{ 'animate-enter': showResultPopup }">
            <img src="https://assets.hzwxbz2.cn/sy/hm_act/img/red_bg.png" />
            <div class="result-content ab_x_center">
              <div class="result-title text_center mb_5">{{ voucherData.name }}</div>
            </div>
            <div v-if="voucherData.invalid_time" class="result-time ab_x_center">
              有效期：{{ voucherData.invalid_time }}，可前往游戏使用
            </div>
            <template v-if="!voucherData.invalid_time && voucherData.relative_invalid_time">
              <van-count-down
                class="result-time ab_x_center"
                :time="voucherData.relative_invalid_time"
                format="领取 DD 天 HH 时 mm 分后失效"
              />
            </template>
            <i class="iconfont yw-close result-close ab_x_center" @click="closePopup"></i>
          </div>
        </div>
      </transition>

      <!-- 账号绑定 -->
      <BindAccountDialog
        ref="bindAccountRef"
        :isCommon="false"
        :actId="actId"
        @update="handleFetchUserInfo"
      />

      <!-- 领取记录弹窗 -->
      <RecordList ref="recordRef" :expoId="activeGame.id" />

      <!-- 一般弹窗 -->
      <Popup
        :visible.sync="visible"
        v-bind="feedback"
        :headerStyle="{
          background: '#FFCA68',
        }"
        confirmButtonColor="#E46432"
        cancelButtonColor="#9D9D9D"
        @confirm="feedback.onSure"
        @cancel="feedback.onCancel"
      >
        <!-- 活动规则 -->
        <template v-if="feedbackType === 0">
          <div class="rule_wrap" v-html="activeInfo.rule"></div>
        </template>
        <!-- 奖励介绍 -->
        <template v-if="feedbackType === 1">
          <div :style="{ lineHeight: '30px' }">可能抽中的红包如下：</div>
          <div
            v-for="(item, index) in voucherList"
            :key="`${index}-${item.act_voucher_name}`"
            :style="{ lineHeight: '30px' }"
          >
            {{ item.act_voucher_name }}
          </div>
        </template>
        <template v-if="feedbackType === 3">
          <div class="f3_wrap fs_12">
            <div class="code_wrap flex_between mb_12">
              <div class="code_main">激活码：{{ roleGiftRes.code }}</div>
              <div class="code_btn">
                <van-button
                  v-clipboard="roleGiftRes.code"
                  round
                  size="mini"
                  color="#F84C4C"
                  style="width: 60px"
                  >复制</van-button
                >
              </div>
            </div>
            <p class="fs_12" style="color: #d62828">礼包有时间限制，请及时前往游戏中兑换</p>
          </div>
        </template>
      </Popup>
    </template>
  </div>
</template>

<script>
import Banner from './components/retourGame/Banner.vue';
import { CountDown, NoticeBar, Button } from 'vant';
import BindAccountDialog from '@/components/CustomDialogs/BindAccountDialog.vue';
import Popup from '@/components/activityComps/Popup.vue';
import RecordList from './components/retourGame/RecordList.vue';
import {
  retourGameActInfo,
  retourGameExpoInfo,
  retourGameRewardInfo,
  retourGameGetRoleGift,
  retourGameGetReward,
  retourGameGetRedBag,
  retourGameReport,
} from '@/api/activity';

const MAP_KEY = 'la_token_map';

export default {
  components: {
    Banner,
    [Button.name]: Button,
    VanCountDown: CountDown,
    VanNoticeBar: NoticeBar,
    BindAccountDialog,
    Popup,
    RecordList,
  },
  data() {
    return {
      activeInfo: {}, // 当前活动信息
      expoInfo: {}, // 当前会场信息
      activeGame: {}, // 当前选中会场
      game_account: '', // 用户账号
      feedbackType: 0, // 弹窗类型
      visible: false, // 一般弹窗是否显示
      // 创角礼包结果
      roleGiftRes: {
        code: '', // 礼包码
        type: '', // 领取条件类型
        url: '', // 计划链接
        word: '', // 展示文案
      },
      voucherList: [], // 奖励介绍 - 代金券列表
      showResultPopup: false, // 是否展示奖励弹窗
      // 开红包奖励获取的代金券信息
      voucherData: {
        name: '',
        invalid_time: '',
        relative_invalid_time: 0,
      },
      userInfo: null, // 用户信息
      buttonLock: false, // 按钮锁定
      buttonTimer: null,
    };
  },
  async created() {
    this.getActInfo();
  },
  mounted() {
    document.title = '转游开红包';
  },
  computed: {
    // 活动页面状态
    actStatus() {
      if (!this.activeInfo) return 1; // 活动数据异常
      if (this.activeInfo.status === 0) return 2; // 活动已结束
      if (this.activeInfo.status === 2) return 3; // 活动未开始
      if (
        this.activeInfo.status === 1 &&
        (!this.activeInfo.expo_list || !this.activeInfo.expo_list.length)
      )
        return 4; // 活动无会场数据

      return 0;
    },
    // 活动状态异常提示词
    actTip() {
      switch (this.actStatus) {
        case 0:
          return '';
        case 1:
        case 2:
          return '活动已结束';
        case 3:
          return `活动将于 ${this.activeInfo.begin_time} 开始`;
        case 4:
          return '福利上架中';
        default:
          return '活动已结束';
      }
    },
    // 活动 id
    actId() {
      return this.$route.query.id;
    },
    // 游戏会场列表
    gameList() {
      return this.activeInfo.expo_list || [];
    },
    // 活动倒计时
    countDownTime() {
      return this.expoInfo.countdown_second ? this.expoInfo.countdown_second * 1000 : 0;
    },
    // 当前选中的会场任务数据
    gameConditionData() {
      return this.expoInfo.expo_condition_data || {};
    },
    // 一般弹窗类型
    feedback() {
      return this.feedbackMap[this.feedbackType] || {};
    },
    // 一般弹窗配置
    feedbackMap() {
      return [
        {
          title: '活动规则',
          message: [],
          showCancelButton: false,
          showConfirmButton: false,
          onCancel: () => {
            this.triggerVisible(false);
          },
          onSure: () => {
            this.triggerVisible(false);
          },
        },
        {
          title: '奖励介绍',
          message: [],
          confirmButtonText: '我知道了',
          onCancel: () => {
            this.triggerVisible(false);
          },
          onSure: () => {
            this.triggerVisible(false);
          },
        },
        {
          title: '不满足领取条件',
          message: [this.roleGiftRes.word],
          confirmButtonText: '去完成',
          onCancel: () => {
            this.handleGetRoleGiftDone(true);
          },
          onSure: () => {
            this.handleGetRoleGiftDone(false);
          },
        },
        {
          title: '领取成功',
          message: [],
          confirmButtonText: '确认',
          onCancel: () => {
            this.triggerVisible(false);
          },
          onSure: () => {
            this.triggerVisible(false);
          },
        },
      ];
    },
  },
  methods: {
    // 获取活动信息
    async getActInfo() {
      console.log('get act info', this.actId, this.userInfo);
      if (!this.actId) return;

      const res = await retourGameActInfo({ id: this.actId });

      if (res.data) {
        // 全局活动信息
        this.activeInfo = res.data;
        this.game_account = res.data.game_account;
        // 设置当前选中第一个游戏会场
        if (res.data.expo_list && res.data.expo_list.length) {
          this.chooseGame(res.data.expo_list[0] || {});
        }
        // 设置 token
        const _KEY = 'laToken' + this.actId;
        const actToken = res.data[_KEY];
        if (!this.getLaToken() && actToken) {
          // 本地无 laToken，但是用户已经绑定过账号了
          // 1. 重新设置 laToken
          this.setLaToken(actToken);
          // 2 重新请求一次活动信息接口
          this.getActInfo();
        }

        this.reportPoint({ data_type: 1 });
      }
    },
    // 选择游戏
    async chooseGame(game) {
      this.activeGame = game || {};

      this.reportPoint({ data_type: 4, expo_id: game.id, expo_name: game.name });

      // 请求当前会场详情
      retourGameExpoInfo({ id: this.actId, expo_id: game.id })
        .then((res) => {
          this.expoInfo = res.data || {};
        })
        .catch((err) => {
          this.expoInfo = {};
        });
    },
    // 奖励按钮文案
    rewardButtonText(status) {
      switch (status) {
        case 0:
          return '领取';
        case 1:
          return '已领取';
        case 2:
          return '已过期';
        default:
          return '';
      }
    },
    // 弹窗显示
    triggerVisible(v, type) {
      if (type !== undefined) {
        this.feedbackType = type;
      }
      this.visible = v;
    },
    unLockButton() {
      clearTimeout(this.buttonTimer);

      this.buttonTimer = setTimeout(() => {
        this.buttonLock = false;
      }, 300);
    },
    // 点击领取创角好礼
    async handleGetRoleGift() {
      if (this.buttonLock) return;

      this.reportPoint({
        data_type: 6,
        expo_id: this.activeGame.id,
        expo_name: this.activeGame.name,
        receive_name: this.expoInfo.role_show_gift_name, // 领取名称
        role_gift_id: this.expoInfo.role_gift_id, // 创角礼包 id
        show_condition_rule: this.expoInfo.role_show_condition_rule, // 领取条件
      });
      if (!this.validateBinding(false)) {
        this.bindAccount();
        return;
      }

      try {
        this.buttonLock = true;
        // 请求领取礼包
        const res = await retourGameGetRoleGift({ id: this.actId, expo_id: this.activeGame.id });
        this.unLockButton();

        // 不满足条件
        if (res.data.role_gift_receive_status === 0) {
          this.roleGiftRes.type = res.data.type;
          this.roleGiftRes.word = `${this.expoInfo.role_show_condition_rule}可领取`;
          this.triggerVisible(true, 2);
          this.reportPoint({
            data_type: 7,
            expo_id: this.activeGame.id,
            expo_name: this.activeGame.name,
            receive_name: this.expoInfo.role_show_gift_name, // 领取名称
            role_gift_id: this.expoInfo.role_gift_id, // 创角礼包 id
            show_condition_rule: this.expoInfo.role_show_condition_rule, // 领取条件
          });
          return;
        }
        // 领取成功
        if (res.data.role_gift_receive_status === 1) {
          // 刷新会场信息
          this.chooseGame(this.activeGame);
          this.reportPoint({
            data_type: 8,
            expo_id: this.activeGame.id,
            expo_name: this.activeGame.name,
            receive_name: this.expoInfo.role_show_gift_name, // 领取名称
            role_gift_id: this.expoInfo.role_gift_id, // 创角礼包 id
            show_condition_rule: this.expoInfo.role_show_condition_rule, // 领取条件
          });
          this.roleGiftRes.code = res.data.role_gift_code;
          this.triggerVisible(true, 3);
          return;
        }
        // 没有礼包码情况下的，领取失败
        if (res.data.role_gift_receive_status === 2) {
          this.$toast('领取失败，请联系客服领取');
          // 刷新会场信息
          this.chooseGame(this.activeGame);
          return;
        }
      } catch (error) {
        this.unLockButton();
      }
    },
    // 不满足条件，点击去完成
    handleGetRoleGiftDone(isClose) {
      if (!isClose) {
        // 领取条件 != 累计进入游戏会场天数时，打开对应游戏计划链接
        if (this.roleGiftRes.type !== 6) {
          console.log('game url', this.activeGame.download_url);
          // 跳转下载游戏链接
          window.open(this.activeGame.download_url, '_self');
        }
      }

      // 关闭弹窗
      this.triggerVisible(false);
      this.roleGiftRes = { code: '', type: '', url: '', word: '' };
    },
    // 点击显示活动规则
    handleRule() {
      this.triggerVisible(true, 0);
      this.reportPoint({ data_type: 3, button_text: '活动规则' });
    },
    // 点击奖励介绍
    async handleIntroduce() {
      this.reportPoint({ data_type: 3, button_text: '奖励介绍' });
      if (!this.validateBinding(false)) {
        this.bindAccount();
        return;
      }
      const res = await retourGameRewardInfo({ id: this.actId, expo_id: this.activeGame.id });

      if (!res.data || !res.data.voucher_list) return;

      this.voucherList = res.data.voucher_list;
      this.triggerVisible(true, 1);
    },
    // 点击领取奖励
    async handleGetReward(condition) {
      if (this.buttonLock) return;

      this.reportPoint({
        data_type: 6,
        expo_id: this.activeGame.id,
        expo_name: this.activeGame.name,
        receive_name: `开红包${condition.count}次`, // 领取名称
        role_gift_id: condition.id, // 创角礼包 id
        show_condition_rule: condition.show_condition_rule, // 领取条件
      });
      if (!this.validateBinding(false)) {
        this.bindAccount();
        return;
      }
      try {
        this.buttonLock = true;
        // 请求领取奖励
        const res = await retourGameGetReward({
          id: this.actId,
          expo_id: this.activeGame.id,
          condition_id: condition.id,
        });
        this.unLockButton();

        // 领取失败
        if (res.data.condition_status === 0) {
          this.roleGiftRes.type = res.data.type;
          this.roleGiftRes.word = `${condition.show_condition_rule}可领取`;
          this.triggerVisible(true, 2);
          this.reportPoint({
            data_type: 7,
            expo_id: this.activeGame.id,
            expo_name: this.activeGame.name,
            receive_name: `开红包${condition.count}次`, // 领取名称
            role_gift_id: condition.id, // 创角礼包 id
            show_condition_rule: condition.show_condition_rule, // 领取条件
          });
        } else if (res.data.condition_status === 1) {
          this.$toast(`开红包次数+${condition.count}`);
          // 刷新会场信息
          this.chooseGame(this.activeGame);
        }
      } catch (error) {
        this.unLockButton();
      }
    },
    // 点击开红包
    async handleOpenReward() {
      if (this.buttonLock) return;

      const currentRemainCount = this.gameConditionData.remain_count || 0;

      this.reportPoint({
        data_type: 10,
        expo_id: this.activeGame.id,
        expo_name: this.activeGame.name,
        remain_count: currentRemainCount,
      });

      if (!this.validateBinding(false)) {
        this.bindAccount();
        return;
      }

      if (currentRemainCount === 0) {
        this.$toast('完成下方任务可获得开红包机会');
        return;
      }

      this.voucherData = { name: '', invalid_time: '', relative_invalid_time: 0 };

      try {
        this.buttonLock = true;
        // 请求开红包
        const res = await retourGameGetRedBag({ id: this.actId, expo_id: this.activeGame.id });

        this.unLockButton();

        if (!res.data) return;

        this.voucherData = {
          name: res.data.name,
          invalid_time: res.data.invalid_time,
          relative_invalid_time: res.data.relative_invalid_time * 60 * 1000,
        };

        this.showResultPopup = true;

        this.reportPoint({
          data_type: 9,
          expo_id: this.activeGame.id,
          expo_name: this.activeGame.name,
          act_voucher_name: res.data.name,
          act_voucher_id: res.data.id,
          show_condition_rule: '',
        });

        // 刷新当前会场详情
        retourGameExpoInfo({ id: this.actId, expo_id: this.activeGame.id })
          .then((res) => {
            this.expoInfo = res.data || {};
          })
          .catch((err) => {
            this.expoInfo = {};
          });
      } catch (error) {
        this.unLockButton();
      }
    },
    // 关闭奖励弹窗
    closePopup() {
      this.voucherData = { name: '', invalid_time: '', relative_invalid_time: 0 };
      this.showResultPopup = false;
    },
    // 点击跳转领取记录
    handleRewardList() {
      this.reportPoint({ data_type: 3, button_text: '领取记录' });
      if (!this.validateBinding(false)) {
        this.bindAccount();
        return;
      }
      this.$refs.recordRef.triggerVisible(true);
    },
    // 埋点上报
    reportPoint(data) {
      const params = { id: this.actId, act_name: this.activeInfo.name, ...data };

      retourGameReport(params);
    },

    // 点击账号绑定
    handleBindAccount() {
      this.reportPoint({ data_type: 2 });
      if (this.$refs.bindAccountRef) {
        this.$refs.bindAccountRef.triggerVisible(true);
      }
    },
    // 打开账号绑定弹窗
    bindAccount() {
      if (this.$refs.bindAccountRef) {
        this.$refs.bindAccountRef.triggerVisible(true);
      }
    },
    // 绑定账号，获取用户 token
    handleFetchUserInfo(laTokenStr) {
      if (laTokenStr) {
        // 设置 token
        this.setLaToken(laTokenStr);
        // 重新获取活动信息
        this.getActInfo();
      }
    },
    // 设置 la_token
    setLaToken(tokenStr) {
      const _KEY = 'laToken' + this.actId;
      const tokenSet = JSON.parse(localStorage.getItem(MAP_KEY) || '{}');
      tokenSet[_KEY] = tokenStr;
      localStorage.setItem(MAP_KEY, JSON.stringify(tokenSet));
    },
    // 获取 la_token
    getLaToken() {
      const _KEY = 'laToken' + this.actId;
      const tokenSet = JSON.parse(localStorage.getItem(MAP_KEY) || '{}');
      const tokenStr = tokenSet[_KEY];

      return tokenStr || '';
    },
    // 校验当前是否绑定账号
    validateBinding(autoTrigger = true) {
      const tokenSet = JSON.parse(localStorage.getItem(MAP_KEY) || '{}');
      const CURRENT_KEY = `laToken${this.actId}`;
      const token = tokenSet[CURRENT_KEY];
      const isValid = token && token.length && this.game_account;
      // 如果没有绑定，则弹出绑定框
      if (!isValid && autoTrigger) {
        this.bindAccount();
      }
      return isValid;
    },
  },
};
</script>

<style>
.van-notice-bar__wrap {
  justify-content: center;
}
</style>

<style lang="scss" scoped>
// --- Popup Styles ---
.blind-box-result-popup {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  z-index: 100;
  perspective: 1000px;
  padding-top: 50px;

  .popup-content {
    padding: 30px;
    border-radius: 10px;
    text-align: center;
    min-width: 250px;
    transform-style: preserve-3d;
    backface-visibility: hidden;
    transform: scale(0.5) rotateY(0deg) translate3d(0, 0, 0); // Initial state for animation

    // Apply animation when class is added
    &.animate-enter {
      animation: popup-content-enter 2.5s cubic-bezier(0.1, 0.7, 0.3, 1) both;
    }

    img {
      width: 269px;
    }

    .result-content {
      width: 257px;
      top: 304px;
      padding: 6px 12px;
    }

    .result-title {
      font-size: 21.5px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      color: #fffdd1;
    }

    .result-desc {
      font-size: 10.5px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      color: #fffdd1;
    }

    .result-time {
      width: 140px;
      top: 390px;
      font-size: 10px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #fffdd1;
    }

    .result-close {
      top: 460px;
      font-size: 30px;
      color: #fff;
      font-weight: bold;
    }
  }
}
.rule_wrap {
  white-space: pre-wrap;
  line-height: 1.25;
  max-height: 360px;
  padding: 12px 0;
  overflow: auto;
}
// --- Popup Wrapper Fade Transition ---
.popup-fade-enter-active,
.popup-fade-leave-active {
  transition: opacity 0.5s ease;
}
.popup-fade-enter-from,
.popup-fade-leave-to {
  opacity: 0;
}

// --- Popup Content Enter Animation (Scale + Rotate) ---
@keyframes popup-content-enter {
  from {
    transform: scale(0.5) rotateY(0deg) translate3d(0, 0, 0);
  }
  to {
    transform: scale(1) rotateY(1800deg) translate3d(0, 0, 0);
  }
}
</style>

<style lang="scss" module>
.receive_done {
  filter: grayscale(1);
}
.container {
  width: 100vw;
  min-height: 100vh;
  background-color: #2c0f0c;
  background-image: url('https://assets.hzwxbz2.cn/sy/hm_act/img/main_bg.jpeg');
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 16px 0 48px 0;

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    height: 100vh;
    padding-top: 130px;
    background-color: #f8f8f8;
    color: #919191;
    img {
      width: 100px;
      margin-bottom: 40px;
    }
  }

  .top {
    width: 100%;
    height: 18px;
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .account {
      line-height: 18px;
      font-size: 15px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: left;
      color: #ffd200;
    }

    .rule {
      height: 12px;
      line-height: 12px;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #21f7ea;
      text-decoration: underline;
    }
  }

  .create {
    width: 100%;
    padding: 0 8px;
    margin-bottom: 24px;

    .create_icon {
      width: 105px;
      object-fit: contain;
      margin-bottom: 10px;
    }

    .create_main {
      width: 358px;
      height: 83px;
      background: #fff5f5;
      border-radius: 7.5px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 12.5px 5px 12.5px 9.5px;
      margin-bottom: 8px;

      .create_img {
        width: 58px;
        height: 58px;
        margin-right: 12px;
        border-radius: 8px;
      }

      .create_content {
        flex: 1;
        display: flex;
        flex-direction: column;

        .create_title {
          width: 100%;
          height: 14px;
          line-height: 15px;
          // margin-bottom: 5px;
          font-size: 15px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          text-align: left;
          color: #712d00;

          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          /* autoprefixer: ignore next */
          -webkit-box-orient: vertical;
        }

        .create_info {
          width: 100%;
          height: 26px;
          line-height: 13.5px;
          font-size: 11px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          text-align: left;
          color: #712d00;
          margin: 5px 0 2.5px 0;
          box-sizing: border-box;

          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /* autoprefixer: ignore next */
          -webkit-box-orient: vertical;
        }

        .create_task {
          width: 100%;
          height: 11px;
          line-height: 12px;
          font-size: 11px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          text-align: left;
          color: #712d00;

          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          /* autoprefixer: ignore next */
          -webkit-box-orient: vertical;
        }
      }

      .create_button {
        width: 70.5px;
        height: 30px;
        background: #ff1839;
        border-radius: 15px;
        font-size: 15px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
        text-align: center;
        line-height: 30px;
        margin-left: 8px;
      }

      .receive_done {
        filter: grayscale(1);
      }
    }
  }

  .task_icon {
    width: 100%;
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin-bottom: 21px;

    .task_img {
      width: 132px;
      object-fit: contain;
      margin-right: 6px;
    }

    .task_countdown {
      display: flex;
      flex-direction: row;
      font-size: 15px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: left;
      color: #ffffff;
      line-height: 20px;

      .task_count {
        font-size: 15px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
        line-height: 20px;
      }
    }
  }

  .task_title {
    width: 274px;
    height: 26px;
    background-image: url('https://assets.hzwxbz2.cn/sy/hm_act/img/title_bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto 6px auto;

    line-height: 26px;
    font-size: 15px;
    font-family: Source Han Sans CN, Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: center;
    color: #fbfbf4;

    .task_notice {
      height: 26px;
    }
  }

  .task_container {
    width: 100%;
    height: 318px;
    background-image: url('https://assets.hzwxbz2.cn/sy/hm_act/img/9081_package_main.png');
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
    margin-bottom: 20px;

    .task_intro,
    .task_record {
      position: absolute;
      right: -1px;
      top: 0;
      width: 60.5px;
      height: 22px;
      background: #99322f;
      border-top-color: #ffde00;
      border-bottom-color: #ffde00;
      border-left-color: #ffde00;
      border-style: solid;
      border-width: 1px;
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;

      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      line-height: 22px;
    }

    .task_record {
      top: 26px;
    }

    .task_times {
      width: 86px;
      height: 23px;
      background-image: url('https://assets.hzwxbz2.cn/sy/hm_act/img/0766_left_bg.png');
      background-repeat: no-repeat;
      background-size: 100%;
      line-height: 23px;
      text-align: center;
      font-size: 15px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translate3d(-50%, 0, 0);

      .task_time {
        color: #fde7c6;
        font-weight: bold;
      }
    }

    .task_bag {
      width: 194px;
      height: 272px;
      background-image: url('https://assets.hzwxbz2.cn/sy/hm_act/img/20250703-114651.png');
      background-repeat: no-repeat;
      background-size: 100%;
      position: absolute;
      top: 12px;
      left: 50%;
      transform: translate3d(-50%, 0, 0);

      animation: rotate-swing 400ms infinite alternate ease-in-out;
      transform-style: preserve-3d;

      .task_button {
        width: 104px;
        object-fit: contain;
        position: absolute;
        top: 104px;
        left: 51%;
        transform: translate3d(-50%, 0, 0);

        animation: scale-trans 200ms infinite alternate ease-in-out;
        transform-style: preserve-3d;
      }
    }

    @keyframes rotate-swing {
      0% {
        transform: translate3d(-50%, 0, 0) scale(1) rotateZ(-6deg);
      }
      50% {
        transform: translate3d(-50%, 0, 0) scale(0.95) rotateZ(0deg);
      }
      100% {
        transform: translate3d(-50%, 0, 0) scale(0.95) rotateZ(6deg);
      }
    }

    @keyframes scale-trans {
      0% {
        transform: translate3d(-50%, 0, 0) scale(0.9);
      }
      100% {
        transform: translate3d(-50%, 0, 0) scale(1);
      }
    }
  }

  .reward {
    width: 355px;
    background: #99322f;
    border-radius: 8px;
    margin: 0 auto;
    padding: 20px 16px;

    .reward_content {
      width: 322px;
      height: 63px;
      background: #fff5f5;
      border-radius: 7.5px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 13px 9px 12px 17px;
      margin-bottom: 8px;

      .reward_info {
        flex: 1;
        display: flex;
        flex-direction: column;

        .reward_title {
          width: 100%;
          height: 13px;
          font-size: 14px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          text-align: left;
          color: #712d00;
          // line-height: 13px;
          margin-bottom: 4px;

          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          /* autoprefixer: ignore next */
          -webkit-box-orient: vertical;
        }

        .reward_chance {
          font-size: 10px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          text-align: left;
          color: #712d00;
          line-height: 13px;
        }
      }

      .reward_button {
        width: 70.5px;
        height: 30px;
        background: #ff1839;
        border-radius: 15px;
        margin-left: 8px;
        font-size: 15px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
        text-align: center;
        line-height: 30px;
      }
    }
  }
}

.container_empty {
  padding: 0;
}
</style>
